<template>
    <div class="">
        <h5 class="info-head">其他信息<span v-if="!isShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别或审批中的资质文件,无法修改)</span></h5>
        <el-form :model="other" label-width="200px" :rules="rules" ref="otherForm" class="supplier-form">
            <el-form-item label="注册资金（万元）" prop="fregistermoney">
                <el-input type="text" v-model="other.fregistermoney" auto-complete="off"></el-input>(若为分公司非独立法人请填0)
            </el-form-item>
            <el-form-item label="企业性质：" prop="fenterprisekind">
                <el-select v-model="other.fenterprisekind" placeholder="请选择" style="float:left">
                    <el-option
                        v-for="name,index in enterpriseTypes"
                        :key="index+1"
                        :label="name"
                        :value="index+1+''">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="简介及服务范围：" prop="fdescriptionL2"><el-input type="textarea" v-model="other.fdescriptionL2" auto-complete="off" placeholder="限350字" :maxlength='350'></el-input></el-form-item>
            <el-form-item label="过去五年承接的项目：" prop="flastfyearprj"><el-input type="textarea" v-model="other.flastfyearprj" auto-complete="off" :maxlength='500'></el-input></el-form-item>
        </el-form>
        <div class="splitter"></div>
        <ul class="item-ul"><li><b>近三年销售额</b><el-button icon="el-icon-plus" @click="addYearSales" v-if="yearsales.length<3">新增</el-button></li></ul>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th><b>*</b>年份</th>
                <th>销售额（万元）</th>
                <th>操作</th>
            </tr>
            <tr v-for="s, i in yearsales">
                <td>{{i+1}}</td>
                <td>{{s.fyear}}</td>
                <td>{{s.fsalecount}}</td>
                <td><a @click.prevent="editSales(i)" class="edit-btn">编辑</a></td>
            </tr>
            <tr v-if="!yearsales.length"><td colspan=5>暂无数据</td></tr>
        </table>
        <div class="splitter"></div>
        <ul class="item-ul"><li><b>业绩信息</b><el-button icon="el-icon-plus" @click="addAchieve">新增</el-button></li></ul>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th><b>*</b>工程名称</th>
                <th><b>*</b>客户名称</th>
                <th><b>*</b>工程地址</th>
                <th>联系人</th>
                <th>联系电话</th>
                <th><b>*</b>合同总额</th>
                <th>开始日期</th>
                <th><b>*</b>结束日期</th>
                <th>备注</th>
                <th>附件</th>
                <th>操作</th>
            </tr>
            <tr v-for="a, i in achievements">
                <td>{{i+1}}</td>
                <td>{{a.fprojectname}}</td>
                <td>{{a.fclientname}}</td>
                <td>{{a.fclientaddress}}</td>
                <td>{{a.fclientlinkperson}}</td>
                <td>{{a.fphone}}</td>
                <td>{{a.fcontractpay}}</td>
                <td>{{a.fstartdate|date}}</td>
                <td>{{a.fenddate|date}}</td>
                <td>{{a.fremark}}</td>
                <td>
                    <div v-for="file in a.baseFiles" :key="file.id">
                        <a class="vlink" v-if="file.id"
                           :href="`${baseUrl}rest/file/down?fileId=${file.id}`">
                            {{file.fileOldName}}
                        </a>
                        <span v-else>{{file.fileOldName}}</span>
                    </div>
                </td>
                <td>
                    <a @click.prevent="editAchieve(i)" class="edit-btn">编辑</a>
                    <a @click.prevent="deleteAchieve(i)" class="delete-btn">删除</a>
                </td>
            </tr>
            <tr v-if="!achievements.length"><td colspan=12>暂无数据</td></tr>
        </table>
        <div class="splitter"></div>
        <ul class="item-ul"><li><b>资质文件<span v-if="isAudExist=='1'" style="margin-left:12px;color:red;font-weight:normal;">(审批中)</span></b><el-button v-if="isShow" icon="el-icon-plus" @click="addApt">新增</el-button></li></ul>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th><b>*</b>资质名称及等级</th>
                <th><b>*</b>开始时间</th>
                <th><b>*</b>到期时间</th>
                <th>颁发单位</th>
                <th>备注</th>
                <th><b>*</b>附件</th>
                <th>状态</th>
                <th>操作</th>
            </tr>
            <tr v-for="f, i in aptitudefiles">
                <td>{{i+1}}</td>
                <td>{{f.typeName}}</td>
                <td>{{f.fstartdate|date}}</th>
                <td :class="{colorDate:f.isOutTime==1}">{{f.fenddate|date}}</td>
                <td>{{f.fawardunit}}</td>
                <td>{{f.fremark}}</td>
                <td>
                    <div v-for="file in f.baseFiles" :key="file.id">
                        <a class="vlink"
                           :href="`${baseUrl}rest/file/down?fileName=${file.fileName}&fileOldName=${encodeURIComponent(file.fileOldName)}`">
                            {{file.fileOldName}}
                        </a>
                    </div>
                </td>
                <td>{{f.auditExplain || '待提交'}}</td>
                <td>
                    <a v-if="isShow&&f.auditExplain&&f.auditExplain.includes('已审批')"  @click.prevent="editApt(i)" class="edit-btn">变更</a>
                    <a v-if="isShow&&(!f.auditExplain||(f.auditExplain&&f.auditExplain.includes('不通过')))"  @click.prevent="editApt(i)" class="edit-btn">编辑</a>
                    <a v-if="isShow&&(hasLittleStatus012||(!f.auditExplain||f.auditExplain.includes('不通过')))"  @click.prevent="removeApt(i)" class="delete-btn">删除</a>
                </td>
            </tr>
            <tr v-if="!aptitudefiles.length"><td colspan=9>暂无数据</td></tr>
        </table>

        <el-dialog :title="isNaN(editIndex)?'新增资质文件':'编辑资质文件'" :visible.sync="aptitudeFormVisible">
            <el-form :model="aptitude" label-width="150px" :rules="rulesAptitude" ref="aptitudeForm" class="supplier-form">
                <el-form-item label="资质名称及等级：" prop="typeName">
	                <el-cascader @change="selectApt" ref="aptTyper" v-model="aptType"
	                             placeholder="输入搜索" expand-trigger="hover"
	                             :options="apts" filterable :change-on-select="false"
	                             style="width:100%;"
	                ></el-cascader>
	            </el-form-item>
	            <el-form-item label="开始时间：" prop="fstartdate"><el-date-picker v-model="aptitude.fstartdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker></el-form-item>
                <el-form-item label="到期时间：" prop="fenddate"><el-date-picker v-model="aptitude.fenddate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change="changeEndDate"></el-date-picker></el-form-item>
                <el-form-item label="颁发单位：" prop="fawardunit"><el-input type="text" v-model="aptitude.fawardunit" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="备注：" prop="fremark"><el-input type="text" v-model="aptitude.fremark" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="附件：" prop="baseFiles">
                    <el-upload class="upload"
                        :action="uploadApi"
                        :on-success="handleChange"
                        :on-error="uploadError"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :before-upload="beforeUpload"
                        :limit="3"
                        multiple
                        :on-exceed="handleExceed"
                        :file-list="aptitude.baseFiles">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="aptitudeFormVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="zzCanEdit" @click="submitAptitude">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="isNaN(editIndex)?'新增业绩':'编辑业绩'" :visible.sync="achieveFormVisible">
            <el-form :model="achievement" label-width="100px" :rules="rulesAchievement" ref="achieveForm" class="supplier-form">
                <el-form-item label="工程名称：" prop="fprojectname"><el-input type="text" v-model="achievement.fprojectname" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="客户名称：" prop="fclientname"><el-input type="text" v-model="achievement.fclientname" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="工程地址：" prop="fclientaddress"><el-input type="text" v-model="achievement.fclientaddress" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="联系人：" ><el-input v-model="achievement.fclientlinkperson" type="text" placeholder=""></el-input></el-form-item><!-- prop="fclientlinkperson" -->
                <el-form-item label="联系电话：" ><el-input type="text" v-model="achievement.fphone" auto-complete="off" :maxlength="11"></el-input></el-form-item><!-- prop="fphone" -->
                <el-form-item label="合同总额：" prop="fcontractpay"><el-input type="text" v-model="achievement.fcontractpay" placeholder="请输入数字" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="开始日期：" ><el-date-picker type="date" v-model="achievement.fstartdate" auto-complete="off" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker></el-form-item><!-- prop="fstartdate" -->
                <el-form-item label="结束日期：" prop="fenddate"><el-date-picker type="date" v-model="achievement.fenddate" auto-complete="off" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker></el-form-item>
                <el-form-item label="备注：" prop="fremark"><el-input type="text" v-model="achievement.fremark" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="附件：" prop="">
                    <el-upload class="upload"
                               :action="uploadApi"
                               :on-success="handleChangeAchieve"
                               :on-error="uploadError"
                               :on-preview="handlePreview"
                               :on-remove="handleRemoveAchieve"
                               :before-remove="beforeRemove"
                               :before-upload="beforeUpload"
                               multiple
                               :limit="3"
                               :on-exceed="handleExceed"
                               :file-list="achievement.baseFiles">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="achieveFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAchieve">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="isNaN(editIndex)?'新增近三年销售额':'编辑近三年销售额'" width="640px" :visible.sync="salesFormVisible">
            <el-form :model="yearsale" label-width="100px" :rules="rulesSales" ref="salesForm" class="supplier-form">
                <el-form-item label="年份：" prop="fyear"><el-input type="text" v-model.number="yearsale.fyear" :maxlength="4" auto-complete="off"></el-input></el-form-item>
                <el-form-item label="销售额：" ><el-input type="number" v-model.number="yearsale.fsalecount" auto-complete="off" maxlength="10"><template slot="append">万元</template></el-input></el-form-item><!-- prop="fsalecount" -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="salesFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitSales">确 定</el-button>
            </div>
        </el-dialog>
        <div class="splitter"></div>
        <div class="text-center">
            <el-button v-if="isShow && isAudExist=='0'" :disabled="isSubmit" type="primary" @click="submit">提 交</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { otherRules, salesRules, achievementRules, aptitudeRules } from '@/util/rules'
    import util from '@/util'
    import apis from '@/store/apis'
    import filter from '@/filter'

    export default {
        name: 'supplier-other',
        filters: filter,
        data () {
            return {
                baseUrl: util.baseUrl,
                rules: otherRules,
                rulesSales: salesRules,
                rulesAchievement: achievementRules,
                rulesAptitude: aptitudeRules,
                isShow: true,  // 判断信息是否修改
                basicIsShow: true,//存在入库审批中国的信息
                hasLittleStatus012: {flag:false},
                hasLittleStatus3: {flag:false},
                yearsale: {//（近三）年销售
                    fyear: '',
                    fsalecount: ''
                },
                achievement: {//业绩
                    fprojectname: '',//工程名称
                    fclientname: '',//客户名称
                    fclientaddress: '',//工程地址
                    fclientlinkperson: '',//客户联系人
                    fphone: '',//电话
                    fcontractpay: '',//合同金额
                    fstartdate: '',//开始日期
                    fenddate: '',//结束日期
                    fremark: '',//备注
                    baseFiles:[]
                },
                aptitude: {
                    faptnumber:'',
                    faptname:'',
                    faptlevel:'',
                    fstartdate:'',
                    fenddate:'',
                    fawardunit:'',
                    fremark:'',
                    typeParents:'',
                    typeName:'',
                    qualificationId:'',
                    baseFiles:[]
                },//资质
                aptType:[],
                salesFormVisible: false,
                achieveFormVisible: false,
                aptitudeFormVisible: false,
                fileList:[] ,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                editIndex:void(0),
                isSubmit:false,
                isAudExist:'1',
                zzCanEdit:true
            }
        },
        computed: mapGetters(['other','enterpriseTypes','yearsales','achievements','aptitudefiles','apts']),
        methods: {
            ...mapActions(['getOtherInfo','checkOtherInfo','addOrEditSales','addOrEditAchieve','removeAchieve','addOrEditApt','removeApt','getApt','basic']),
            addYearSales(){
                this.editIndex = void(0)
                this.salesFormVisible = true

                this.yearsale = {
                    fyear: '',
                    fsalecount: ''
                }

                this.$nextTick(()=>{

                    this.$refs.salesForm.resetFields()
                    let thisYear = (new Date).getFullYear()
                    switch(this.yearsales.length){
                        case 2: this.yearsale.fyear = thisYear - 2; break;
                        case 1: this.yearsale.fyear = thisYear - 1; break;
                        default: this.yearsale.fyear = thisYear
                    }
                })
            },
            addAchieve(){
                this.editIndex = void(0)
                this.achieveFormVisible = true

                this.achievement = {
                    fprojectname: '',
                    fclientname: '',
                    fclientaddress: '',
                    fclientlinkperson: '',
                    fphone: '',
                    fcontractpay: '',
                    fstartdate: '',
                    fenddate: '',
                    fremark: '',
                    baseFiles: []
                }

                this.$nextTick(()=>{
	                this.achievement = {
	                    fprojectname: '',
	                    fclientname: '',
	                    fclientaddress: '',
	                    fclientlinkperson: '',
	                    fphone: '',
	                    fcontractpay: '',
	                    fstartdate: '',
	                    fenddate: '',
	                    fremark: '',
	                    baseFiles: []
	                }
                    this.$refs.achieveForm.resetFields()
                })
            },
            addApt(){
                this.editIndex = void(0)
                this.aptitudeFormVisible = true

                this.aptitude = {
                    faptnumber:'',
                    faptname:'',
                    faptlevel:'',
                    fstartdate:'',
                    fenddate:'',
                    fawardunit:'',
                    fremark:'',
                    typeParents:'',
                    typeName:'',
                    qualificationId:'',
                    baseFiles:[]
                }
				this.aptType=[];

                this.$nextTick(() => {
	                this.aptitude = {
	                    faptnumber:'',
	                    faptname:'',
	                    faptlevel:'',
	                    fstartdate:'',
	                    fenddate:'',
	                    fawardunit:'',
	                    fremark:'',
	                    typeName:'',
	                    typeParents:'',
	                    qualificationId:'',
	                    baseFiles:[]
	                }
                    this.$refs.aptitudeForm.resetFields()

                })
            },
            editSales(i){
                this.editIndex = i
                this.salesFormVisible = true
                this.yearsale = Object.assign({}, this.other.yearsales[i])
            },
            editAchieve(i){
                this.editIndex = i
                this.achieveFormVisible = true
                this.achievement = Object.assign({}, this.other.achievements[i])
            },
            editApt(i){
                this.editIndex = i
                this.aptitudeFormVisible = true
                this.aptitude = Object.assign({}, this.other.aptitudefiles[i])
                if( !(new Date().getTime() > new Date(this.aptitude.fenddate.replace(/\-/g, '/')).getTime())){
                    this.zzCanEdit = false
                }
                this.$nextTick(()=>{
                    this.aptType = this.aptitude.typeParents.split(',')
                })
            },
            deleteAchieve(i){
                this.$confirm('您确定要删除该条记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeAchieve(i)
                    this.$alert('删除成功!')
                }).catch(() => {
                    this.$alert('已取消删除')
                })
            },
            deleteApt(i){
                this.$confirm('您确定要删除该条记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeApt(i)
                    this.$alert('删除成功!')
                }).catch(() => {
                    this.$alert('已取消删除')
                })
            },
            submitSales(){
                var re = /^[0-9]+.?[0-9]*$/;
                if(!re.test(this.yearsale.fsalecount)){
                    this.$message({message: '销售额必须为数字', type: 'error'})
                    return
                }
                this.$refs.salesForm.validate((valid) => {
                    if (valid) {
                        let payload = {yearsale:this.yearsale, editIndex:this.editIndex}
                        this.addOrEditSales( payload )
                        this.salesFormVisible = false
                    }
                })
            },
            submitAchieve(){
                var re = /^[0-9]+.?[0-9]*$/;
                if(!re.test(this.achievement.fcontractpay)){
                    this.$message({message: '合同金额请输入数字', type: 'error'})
                    return
                }
                this.$refs.achieveForm.validate((valid) => {
                    if (valid) {
                        let payload = {achievement:this.achievement, editIndex:this.editIndex}
                        this.addOrEditAchieve( payload )
                        this.achieveFormVisible = false
                    }
                })
            },
            submitAptitude(){

                this.$refs.aptitudeForm.validate((valid) => {
                    if (valid) {

                    	if(new Date(this.aptitude.fstartdate).getTime()>new Date().getTime()){
                    		this.$message({message: '开始时间不能大于当前时间', type: 'error'})
                    		return
                    	}
                    	if(new Date(this.aptitude.fstartdate).getTime()>new Date(this.aptitude.fenddate).getTime()){
                    		this.$message({message: '开始时间不能大于到期时间', type: 'error'})
                    		return
                    	}
                        let payload = {aptitude:this.aptitude, editIndex:this.editIndex}
                        this.addOrEditApt( payload )
                        this.aptitudeFormVisible = false
                    }
                })
            },
            submitFunc(){
                // verify 3 tables
                //按钮控制
                this.isSubmit=true;
                this.$root.loading = true
                this.checkOtherInfo({
                    success:(res)=>{
                        this.isSubmit=false;
                        this.$root.loading = false
                        if(res.data.result){
                            this.$confirm(res.data.message||'操作成功！', '', {
                                confirmButtonText: '确定',
                                showCancelButton: false,
                                showClose: false,
                                type: 'success',
                                center: true
                            }).then(() => {
                                window.location.reload()
                            },() => {
                                window.location.reload()
                            })
                            window.sessionStorage.setItem(this.$route.name,'saved')
                        }else{
                            this.$alert(res.data.message)
                        }
                    },
                    error:()=>{
                        this.isSubmit=false;
                        this.$root.loading = false
                    }
                })
            },
            submit(){
                this.$refs.otherForm.validate((valid) => {
                    if (valid) {
                        let flag = true;
                        this.other.aptitudefiles.forEach(function(a){
                            if(!!a.auditExplain && a.auditExplain.indexOf('审批中') != -1) flag = false;
                        });
                        if(flag){
                            this.submitFunc();
                        }else{
                            this.$confirm('存在审批中的资质文件，提交会根据原来数据再次提交审批，是否确定提交？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(()=> {
                                this.submitFunc();
                            }).catch(()=> {
                                /*取消*/
                            })
                        }
                    }
                })
            },
            handleChangeAchieve(response, file, fileList){
                this.achievement.baseFiles = __getBaseFiles__(file,fileList)
            },
            handleRemoveAchieve(file, fileList) {
                this.achievement.baseFiles = this.achievement.baseFiles.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handleChange(response, file, fileList){
                this.aptitude.baseFiles  = __getBaseFiles__(file,fileList)
            },
            handleRemove(file, fileList) {
                this.aptitude.baseFiles = this.aptitude.baseFiles.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handlePreview(file) {
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeUpload(file){
                if(!util.allowUpload(file.name)){
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                    return false
                }
                return true
            },

            uploadError(){
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
            },
            checkApt(){
            	let data={
            		'id':this.$root.stockId
            	}
                apis.checkOtherApt(data).then((res) => {
                    if(!res.data.result){
                        this.$confirm(`${res.data.message}`, '', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {

                        }).catch(() => {

                        })
                    }
                }, e => this.$alert(e))
            },
            selectApt(types){
                let typer = this.$refs.aptTyper;
                this.aptitude.faptname = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                this.aptitude.typeName = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                this.aptitude.faptnumber = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                this.aptitude.faptlevel = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                this.aptitude.qualificationId = typer.getCheckedNodes()[0].value
                this.aptitude.typeParents = typer.getCheckedNodes()[0].pathLabels.join(',')
                this.$nextTick(()=>{
                    this.aptitude.faptname = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.typeName = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.faptnumber = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.faptlevel = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.qualificationId = typer.getCheckedNodes()[0].value
                    this.aptitude.typeParents = typer.getCheckedNodes()[0].pathLabels.join(',')
                })
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
            },
            changeEndDate(val){
                if( !(new Date().getTime() > new Date(val.replace(/\-/g, '/')).getTime())){
                    this.zzCanEdit = false
                }else{
                    this.zzCanEdit = true
                }
            }
        },
        created(){
            this.$root.loading = true
            let that = this
            Promise.all([this.getApt(), this.getOtherInfo(),this.checkApt(),this.checkStatus()])
                .then((r)=>{
                    that.$root.loading = false;
                    that.isAudExist = that.other.isExist
                    if(that.hasLittleStatus3.flag) {
                        that.isShow = false
                    }else{
                        if(that.isAudExist =='1'){
                            that.isShow = false
                        }
                    }})
                .catch((err)=>this.$root.loading = false)

        }
    }
    function __getBaseFiles__(file,fileList){
        let fs = [];
        fileList.forEach(function (item) {
            if(item.response){
                let f = item.response.basefiles[0];
                item.fileOldName = f.fileoldname;
                item.name = f.fileoldname;
                item.fileName = f.filename;
                item.filePath = f.filepath;
                item.fileSize = f.filesize;
                item.fileType = f.filetype;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        return fs
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import '../../../assets/common.css';

.item-ul{
    list-style: url(../../../assets/imgs/list-type.png);
    font-size: 14px;
}
.vlink {
    color: var(--cTxt2);
}
.colorDate{
	color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Other.vue